import { TranslationKey } from "shared/Modules/Localization/Components/Localized"
import { SubscriptionUsagePeriod } from "shared/Modules/UserCards/userCardsTypes"

const USAGE_PERIOD_MESSAGE_IDS: Partial<Record<SubscriptionUsagePeriod, TranslationKey>> = {
    [SubscriptionUsagePeriod.WEEK]: "home-user-card-lunch-subscription-used-this-week",
    [SubscriptionUsagePeriod.MONTH]: "home-user-card-lunch-subscription-used-this-month",
}

export function getUsagePeriodMessageId(period: string | undefined): TranslationKey | null {
    return period ? USAGE_PERIOD_MESSAGE_IDS[period as SubscriptionUsagePeriod] ?? null : null
}
